// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1pNVJ","resendInfoText":"OnGoingPaymentBox_resendInfoText__1kfEl"};